module.exports = __webpack_public_path__ + "media/images/flags/mc-fed9edeb5b5eb660cd01bd6055e7669e.svg";